import { RectLabelOverlay } from './RectLabelOverlay.js';
import { plotLayout } from '../../../core/components/chart-grid/ChartGrid.sty.js';
import { CANVAS_DIMMED_OPACITY } from '../../../core/utils/apply-opacity-to-canvas.js';
import { zIndicesXYChartAreas } from '../../constants/xy-chart-z-index-areas.js';
import { useRectData } from '../../hooks/useRectData.js';
import { useXYChartScales } from '../../hooks/useXYChartScales.js';
import { useXYChartHighlightedSeriesIdsState } from '../../store/selectors.js';
import { getHighlightedSeries } from '../../utils/get-highlighted-series.js';

/**
 * Chart-level wrapper that mounts the HTML labels for every rect series with
 * `hasLabels === true`. Rendered as a sibling of the canvas plot inside
 * `<ChartGrid.PlotArea>` because HTML cannot live inside `<canvas>` — see
 * `./RectLabelOverlay.tsx` for the per-series clipped-label renderer.
 */
export function RectLabelLayout() {
  const axisIdToScales = useXYChartScales();
  const { filteredSeriesWithDatapoints } = useRectData();
  const highlightedSeriesId = useXYChartHighlightedSeriesIdsState();

  const labelSeries = filteredSeriesWithDatapoints.filter(
    (s) => s.hasLabels === true,
  );

  if (labelSeries.length === 0) {
    return null;
  }

  const highlightedSeries = highlightedSeriesId
    ? getHighlightedSeries(labelSeries, highlightedSeriesId)
    : undefined;

  return (
    <div
      className={plotLayout}
      style={{
        zIndex: zIndicesXYChartAreas.plot + 1,
        pointerEvents: 'none',
      }}
    >
      {labelSeries.map((series) => {
        const opacity =
          highlightedSeries && series !== highlightedSeries
            ? +CANVAS_DIMMED_OPACITY
            : undefined;
        return (
          <RectLabelOverlay
            key={series.id}
            axisIdToScales={axisIdToScales}
            series={series}
            opacity={opacity}
          />
        );
      })}
    </div>
  );
}

RectLabelLayout['displayName'] = 'RectLabelLayout';
